import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Input, Button, notification } from "antd";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ModalCapcha from "../../components/ModalCapcha";

import { getValueFromUrl } from "../../utils/getValueFromUrl";
import {
  searchBang,
  saveSearchValue,
  resetSearchValue,
} from "../../redux/actions/search";

import {
  setValueVisibleFilter,
  setValueFilter,
  searchBangAdv,
} from "../../redux/actions/searchFilter";

import { GetCapCha } from "../../services/search";
import logo from "../../assets/logo.png";
import "./styles.scss";

import Cookies from "js-cookie";
import FilterSpace from "../../pages/FilterSpace";
import ModalReCapcha from "../../components/ModelReCapcha";

const mapStateToProps = (state) => ({
  certSearch: state.searchReducer,
  searchFilter: state.searchFilterReducer,
});

function HeaderLayout(props) {
  const {
    searchFilter,
    searchBang,
    hideSearch,
    showBack,
    certSearch,
    setValueVisibleFilter,
    setLoading,
    setValueFilter,
    searchBangAdv,
    resetSearchValue,
  } = props;
  const { total } = certSearch;

  const history = useHistory();

  const [image, setImage] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { Search } = Input;

  useEffect(() => {
    const params = getValueFromUrl(history);
    let objectData = {
      keyword: params?.keyword,
    };
    if (params.hvt) {
      objectData = { ...objectData, name: params.hvt };
    }
    if (params?.nam) {
      objectData = { ...objectData, year: params?.nam };
    }
    if (params?.donViId) {
      objectData = { ...objectData, donViId: params?.donViId };
    }

    if (params.hvt || params.nam || params.donViId) {
      setValueFilter({
        ...objectData,
        visible: true,
      });
      handleSearch(
        params?.pageNum,
        params?.keyword,
        true,
        params?.hvt,
        params?.nam,
        params?.donViId
      );
    } else {
      setValueFilter({
        ...objectData,
        visible: false,
      });
      handleSearch(params.pageNum, params.keyword, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  const changeSearch = (e) => {
    const { value } = e.target;
    setValueFilter({
      keyword: value,
    });
  };

  const onSearch = async () => {
    if (searchFilter?.keyword) {
      try {
        if (!Cookies.get("code")) {
          // const resData = await GetCapCha({
          //   width: 200,
          //   height: 80,
          // });
          // if (resData) {
          //   setImage(
          //     `data:image/jpeg;base64,${Buffer.from(
          //       resData.data,
          //       "binary"
          //     ).toString("base64")}`
          //   );
          //   setIsModalVisible(true);
          // }
          setIsModalVisible(true);
        } else {
          handleSearch();
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      notification.warning({
        description: "Nhập từ khoá tìm kiếm !",
      });
      return;
    }
  };

  const handleSearch = async (pageNum, keyword, check, hvt, nam, donViId) => {
    setLoading(true);
    if (keyword || searchFilter?.keyword) {
      try {
        if (Cookies.get("code")) {
          // const captcha = Cookies.get("code");
          if (check || searchFilter.visible) {
            const res = await searchBangAdv({
              params: {
                keyword: keyword ? keyword : searchFilter?.keyword,
                pageNum: pageNum ? pageNum : 1,
                pageSize: 5,
                // captcha,
                hvt: hvt ? hvt : searchFilter?.name,
                nam: nam ? nam : searchFilter?.year,
                idtruong: donViId ? donViId : searchFilter?.donViId,
              },
              callback: () => {
                onSearch();
              },
            });
            setLoading(false);
            if (res) {
              // Cookies.set("code", captcha);
              saveSearchValue({
                keyword: keyword ? keyword : searchFilter?.keyword,
                pageNum: pageNum ? pageNum : 1,
                pageSize: 5,
              });
              let objectData = {
                pageNum: 1,
                pageSize: 5,
                keyword: keyword ? keyword : searchFilter?.keyword,
              };
              if (hvt || searchFilter?.name) {
                objectData = {
                  ...objectData,
                  hvt: hvt ? hvt : searchFilter?.name,
                };
              }
              if (nam || searchFilter?.year) {
                objectData = {
                  ...objectData,
                  nam: nam ? nam : searchFilter?.year,
                };
              }
              if (donViId || searchFilter?.donViId) {
                objectData = {
                  ...objectData,
                  donViId: donViId ? donViId : searchFilter?.donViId,
                };
              }
              const search = new URLSearchParams(objectData).toString();
              setIsModalVisible(false);
              history.push({
                pathname: "/main",
                search,
              });
            }
          } else {
            const res = await searchBang({
              params: {
                keyword: keyword ? keyword : searchFilter?.keyword,
                pageNum: pageNum ? pageNum : 1,
                pageSize: 5,
                // captcha,
              },
              callback: () => {
                onSearch();
              },
            });
            if (res) {
              setLoading(false);
              // Cookies.set("code", captcha);
              saveSearchValue({
                keyword: keyword ? keyword : searchFilter?.keyword,
                pageNum: pageNum ? pageNum : 1,
                pageSize: 5,
              });
              const search = new URLSearchParams({
                keyword: keyword ? keyword : searchFilter?.keyword,
                pageNum: pageNum ? pageNum : 1,
                pageSize: 5,
              }).toString();
              setIsModalVisible(false);
              history.push({
                pathname: "/main",
                search,
              });
            }
          }
        } else {
          // const resData = await GetCapCha({
          //   width: 200,
          //   height: 80,
          // });
          // if (resData) {
          //   setImage(
          //     `data:image/jpeg;base64,${Buffer.from(
          //       resData.data,
          //       "binary"
          //     ).toString("base64")}`
          //   );
          //   setIsModalVisible(true);
          // }
          setIsModalVisible(true);
        }
      } catch (error) {
        setLoading(false);
        notification.error({
          description: "Đã có lỗi sảy ra",
        });
      }
    } else {
      notification.warning({
        description: "Nhập từ khoá tìm kiếm !",
      });
      return;
    }
  };

  return (
    <Fragment>
      {showBack ? (
        <Fragment>
          <div className="col-lg-1" />
          <div className="col-12 col-sm-12 col-md-12 col-lg-10">
            <div
              className="d-flex align-items-center justify-content-between px-2 py-3"
              style={{ borderBottom: "1px solid #f0f0f0" }}
            >
              <ArrowBackIcon
                style={{ cursor: "pointer", fontSize: 32 }}
                onClick={() => {
                  if (history.length > 2) {
                    history.goBack();
                  } else {
                    setValueFilter({
                      name: null,
                      year: "2021",
                      donViId: undefined,
                      visible: false,
                      keyword: null,
                    });
                    history.push("/");
                  }
                }}
              />
              <img
                src={logo}
                alt="JBCert Logo"
                onClick={() => {
                  setValueFilter({
                    name: null,
                    year: "2021",
                    donViId: undefined,
                    visible: false,
                    keyword: null,
                  });
                  history.push("/");
                }}
                width={200}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
          <div className="col-lg-1" />
        </Fragment>
      ) : null}

      {showBack ? null : (
        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
          <div className="my-3 p-3 text-center">
            <img
              src={logo}
              alt="JBCert Logo"
              onClick={() => {
                setValueFilter({
                  name: null,
                  year: "2021",
                  donViId: undefined,
                  visible: false,
                  keyword: null,
                });
                history.push("/");
              }}
              width={200}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
      )}

      {hideSearch ? null : (
        <Fragment>
          <div className="col-lg-1" />
          <div className="col-12 col-sm-12 col-md-12 col-lg-10">
            <div className="w-100">
              <Search
                allowClear
                size="large"
                placeholder="Nhập giá trị tìm kiếm"
                style={{
                  borderRadius: 24,
                  boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 6px 0px",
                  lineHeight: 2,
                  width: "100%",
                }}
                value={searchFilter?.keyword}
                onChange={changeSearch}
                // suffix={
                //   <SearchIcon
                //     style={{
                //       color: "#000000a8",
                //       fontSize: 24,
                //       marginLeft: 8,
                //     }}
                //     onClick={(event) => {
                //       event.preventDefault();
                //       onSearch();
                //     }}
                //   />
                // }
                // onPressEnter={() => {
                //   onSearch();
                // }}

                onSearch={onSearch}
                enterButton
              />
            </div>
            <div className="w-100 mt-3 d-flex flex-row justify-content-between align-items-center mb-3">
              <div className="ml-3 mr-3">
                <span style={{ fontSize: 14 }}>
                  Tổng số kết quả tìm kiếm: {total}
                </span>
              </div>
              <Button
                size="small"
                type="primary"
                onClick={() => {
                  setValueVisibleFilter(!searchFilter.visible);
                  resetSearchValue();
                }}
              >
                {searchFilter.visible
                  ? `Ẩn tìm kiếm nâng cao`
                  : `Hiện tìm kiếm nâng cao`}
              </Button>
            </div>
            <div
              style={{
                width: "100%",
                height: searchFilter.visible ? 10 : 0,
                transition: "height 0.6s, margin 0.5s",
                marginBottom: searchFilter.visible ? 20 : 0,
                overflow: "hidden",
              }}
              className={`${searchFilter.visible ? "height-filter" : "a"}`}
            >
              <FilterSpace />
            </div>
          </div>
          <div className="col-lg-1" />
        </Fragment>
      )}
      {isModalVisible && (
        <ModalReCapcha
          setIsModalVisible={setIsModalVisible}
          isModalVisible={isModalVisible}
        />
      )}

      {/*{isModalVisible ? (*/}
      {/*  <ModalCapcha*/}
      {/*    image={image}*/}
      {/*    setIsModalVisible={setIsModalVisible}*/}
      {/*    isModalVisible={isModalVisible}*/}
      {/*    callback={onSearch}*/}
      {/*    setImage={setImage}*/}
      {/*  />*/}
      {/*) : null}*/}
    </Fragment>
  );
}

export default connect(mapStateToProps, {
  searchBang,
  saveSearchValue,
  setValueVisibleFilter,
  setValueFilter,
  searchBangAdv,
  resetSearchValue,
})(HeaderLayout);

// const res = await searchBang({
//   params: {
//     ...params,
//     keyword: keyword ? keyword : searchFilter?.keyword,
//     pageNum: pageNum ? pageNum : 1,
//     pageSize: 5,
//     captcha: Cookies.get("code"),
//   },
//   callback: async () => {
//     const resData = await GetCapCha({
//       width: 200,
//       height: 80,
//     });

//     if (resData) {
//       setImage(
//         `data:image/jpeg;base64,${Buffer.from(
//           resData.data,
//           "binary"
//         ).toString("base64")}`
//       );
//       setIsModalVisible(true);
//     }
//   },
// });

// if (res) {
//   setDisabled(false);
//   const search = new URLSearchParams({
//     ...params,
//     keyword: keyword ? keyword : searchFilter?.keyword,
//     pageNum: pageNum ? pageNum : 1,
//     pageSize: 5,
//   }).toString();
//   setLoading(false);
//   history.push({
//     pathname: "/main",
//     search,
//   });
// }
// console.log("Hello :>> ", Hello);

// const searchData = async (captcha) => {
//   const res = await searchBang({
//     params: {
//       ...params,
//       captcha,
//     },
//     callback: () => {},
//   });
//   if (res) {
//     setDisabled(false);
//     const search = new URLSearchParams({ ...params }).toString();
//     setIsModalVisible(false);
//     Cookies.set("code", captcha);
//     history.push({
//       pathname: "/main",
//       search,
//     });
//   }
// };

// const searchData = async (captcha) => {
//   try {

//   } catch (error) {
//     setLoading(false);
//   }
// };
